const en = {
    translations: {
        "PagesNames.Cards": "Cards",
        "PagesNames.Operations": "Operations",
        "PagesNames.Devices": "Devices",
        "PagesNames.Tanks": "Tanks",
        "PagesNames.Limits": "Limits",
        "PagesNames.Administration": "Administration",
        "PagesNames.UserManagement": "User Management",
        "PagesNames.RoleManagement": "Role Management",
        "PagesNames.OrderHistory": "Changes history",
        "Header.LogoutText": "Logout",
        "Table.Empty": "The list is empty",
        "Table.saveButton": "Save",
        "Table.cancelButton": "Cancel",
        "Cards.editCardHeader": "Edit card",
        "Cards.newCardHeader": "New card",
        "Cards.cardNumber": "Card Number",
        "Cards.cardRfidNumber": "RFID Number",
        "Cards.cardIButtonNumber": "iButton Number",
        "Cards.userName": "User Name",
        "Cards.car": "Car",
        "Cards.description": "Description",
        "Cards.cardType": "Card type",
        "Cards.avtoCardType": "Car",
        "Cards.userCardType": "User",
        "Cards.removeCardPopupHeader": "Card removing",
        "Cards.removeCardPopupMessage": "Do you want remove the card {card number}",
        "Cards.setOrderNumberPopupHeader": "Input order number",
        "Cards.carNumber": "Car number",
        "Cards.orderTs": "Order date",
        "Cards.barcode": "Barcode",
        "CardsPagesNames.Cars": "Cars",
        "CardsPagesNames.Users": "Users",
        "Devices.deviceImei": "Device Imei",
        "Devices.name": "Device Name",
        "Devices.description": "Description",
        "Devices.protocolType": "Protocol Type",
        "Devices.deviceType": "Device Type",
        "Devices.isActive": "Is active",
        "Devices.deviceIoSettings.volumeCountIoId": "Volume count IO id",
        "Devices.deviceIoSettings.volumeRatio": "Ratio",
        "Devices.deviceIoSettings.valveIoId": "Valve IO id",
        "Devices.deviceIoSettings.userKeyIoId": "User Key IO id",
        "Devices.deviceIoSettings.autoKeyIoId": "Auto Key IO id",
        "Devices.withLevelMetterText": "With level metter",
        "Devices.levelMetterSettings.levelMeterInstallHeight": "Level metter installation height",
        "Devices.levelMetterSettings.temperatureIoId": "Temperature IO ID",
        "Devices.levelMetterSettings.temperatureRatio": "Temperature ratio",
        "Devices.levelMetterSettings.temperatureDelta": "Temperature delta",
        "Devices.levelMetterSettings.waterLevelMetterIoId": "Watter level metter IO ID",
        "Devices.levelMetterSettings.watterLevelMetterRatio": "Watter level metter ratio",
        "Devices.levelMetterSettings.waterLevelMetterDelta": "Watter level metter delta",
        "Devices.levelMetterSettings.productLevelMetterIoId": "Product level metter IO ID",
        "Devices.levelMetterSettings.productLevelMetterRatio": "Product level metter ratio",
        "Devices.levelMetterSettings.productLevelMetterDelta": "Product level metter delta",
        "Devices.levelMetterSettings.defaultDensity": "Default density",
        "Devices.levelMetterSettings.densityIoId": "Density IO ID",
        "Devices.levelMetterSettings.densityRatio": "Density ratio",
        "Devices.levelMetterSettings.densityDelta": "Density delta",
        "Operations.cardNumber": "Card number",
        "Operations.userName": "Mechanic",
        "Operations.car": "Car",
        "Operations.operationTs": "Operation time",
        "Operations.startOperationTs": "Start operation time",
        "Operations.endOperationTs": "Finish operation time",
        "Operations.deviceImei": "Device Imei",
        "Operations.rawVolumeData": "Raw volume",
        "Operations.volume": "Volume",
        "Operations.tankBalance": "Tank balance",
        "Operations.limitBalance": "Limit balance",
        "UserManagement.userName": "User Login",
        "UserManagement.firstName": "Name",
        "UserManagement.secondName": "Surname",
        "UserManagement.email": "Email",
        "UserManagement.isActive": "Is Active",
        "UserManagement.roleName": "Role Name",
        "UserManagement.newPassword": "New password",
        "UserManagement.password": "Password",
        "UserManagement.confirmPassword": "Confirm password",
        "UserManagement.passwordAndConfirmNotEqualsError": "Confirm password and password are not equals",
        "UserManagement.userNameEmptyError": "User name could not be empty",
        "Tanks.tankName": "Tank",
        "Tanks.volume": "Volume",
        "Tanks.balance": "Balance",
        "Tanks.minLevel": "Min volume",
        "Tanks.maxLevel": "Max volume",
        "Tanks.Details.maxLevel": "Tank volume",
        "Tanks.Details.calculatedVolume": "Calculated volume",
        "Tanks.fuelType": "Fuel type",
        "Tanks.fuelNumber": "Fuel number",
        "Tanks.areaName": "Area",
        "Tanks.areaDescription": "Description",
        "Tanks.department": "Department",
        "Tanks.usedTankBalance": "Current balance",
        "Tanks.graduations": "Graduations",
        "Tanks.LoLevelNotificationPopupHeader": "Tanks Low Level Notification",
        "Tanks.LoLevelNotificationPopupMessage": "Tanks {tanks} have low level of product",
        "TankOperation.tankName": "Tank",
        "TankOperation.userName": "User name",
        "TankOperation.fuelType": "Fuel type",
        "TankOperation.provider": "Fuel provider",
        "TankOperation.description": "Description",
        "TankOperation.balance": "Delivered",
        "TankOperation.deliveryDate": "Delivery date",
        "TankOperation.completed": "Updated",
        "TanksPagesNames.Tanks": "Tanks",
        "TanksPagesNames.TankOperations": "Tanks operations",
        "TanksPagesNames.TanksStateOperations": "Tanks state operations",
        "TanksOperations.Filter.tankName": "Tank",
        "TanksOperations.Filter.dateFrom": "From date:",
        "TanksOperations.Filter.dateTo": "To date:",
        "TankStateOperation.tankName": "Tank",
        "TankStateOperation.watterLevelHeight": "Watter level (mm)",
        "TankStateOperation.watterLevelVolume": "Watter level (l)",
        "TankStateOperation.productLevelHeight": "Product level (mm)",
        "TankStateOperation.productLevelVolume": "Product level (l)",
        "TankStateOperation.temperature": "Temperature",
        "TankStateOperation.density": "Density",
        "TankStateOperation.weight": "Weight",
        "TankStateOperation.packageTs": "Update time",
        "TankStateOperation.densityUnit": "t/m3",
        "TankStateOperation.weightUnit": "t",
        "Operations.Filter.userName": "User name",
        "Operations.Filter.car": "Car",
        "Operations.Filter.tankName": "Tank",
        "Operations.Filter.fuelType": "Fuel type",
        "Operations.Filter.dateFrom": "From date:",
        "Operations.Filter.dateTo": "To date:",
        "TankStateOperation.Filter.tankName": "Tank",
        "TankStateOperation.Filter.dateFrom": "From date:",
        "TankStateOperation.Filter.dateTo": "To date:",
        "ExtendedIo.ioType": "IO type",
        "ExtendedIo.ioDataType": "Data type",
        "ExtendedIo.ioAddress": "IO id",
        "ExtendedIo.ratio": "Ratio",
        "ExtendedIo.offset": "Offset",
        "ExtendedIo.dataDelta": "Data delta",
        "ExtendedIo.defaultValue": "Default value",
        "ExtendedIo.ioDataAction": "Convert data action",
        "ExtendedIo.ioDataActionParam": "Convert data action param",
        "ExtendedIo.EditTankHeader": "Device Extended IOs",
        "ExtendedIo.watterLevelHeightIoName": "Watter level height",
        "ExtendedIo.watterLevelVolumeIoName": "Watter level volume",
        "ExtendedIo.productLevelHeightIoName": "Product level heigth",
        "ExtendedIo.producLevelVolumeIoName": "Product level volume",
        "ExtendedIo.productLevelHeightIoQualityName": "Product level heigth IO quality",
        "ExtendedIo.watterLevelHeightIoQualityName": "Watter level heigth IO quality",
        "ExtendedIo.producLevelVolumeIoQualityName": "Product level volume IO quality",
        "ExtendedIo.watterLevelVolumeIoQualityName": "Watter level volume IO quality",
        "ExtendedIo.temperatureIoName": "Temperature",
        "ExtendedIo.temperatureIoQualityName": "Temperature IO quality",
        "ExtendedIo.densityIoName": "Density",
        "ExtendedIo.densityIoQualityName": "Density quality",
        "ExtendedIo.pressureIoName": "Pressure",
        "ExtendedIo.pressureIoQualityName": "Pressure IO quality",
        "ExtendedIo.weightIoName": "Weight",
        "ExtendedIo.weightIoQualityName": "Weight IO quality",
        "Popups.OkButtonText": "Ok",
        "Popups.YesButtonText": "Yes",
        "Popups.NoButtonText": "No",
        "Popups.CancelButtonText": "Cancel",
        "LoginPage.UserPasswordError": "Wrong login or password",
        "LoginPage.UnknownServerError": "Unknown service error",
        "LoginPage.UserNameText": "User Name:",
        "LoginPage.PasswordText": "Password:",
        "LoginPage.LoginButtonText": "Log in",
        "Limits.cardNumber": "Card Number",
        "Limits.cardOwnerName": "Car",
        "Limits.fuelType": "Fuel type",
        "Limits.dayLimit": "Day limit",
        "Limits.monthLimit": "Month limit",
        "Limits.dateLimit": "Limit",
        "Limits.endDate": "Date",
        "Limits.limitState": "Limit state",
        "Limits.isEnabled": "Limit active",
        "Limits.notUseLimitState": "Not use limits",
        "Limits.useLimitState": "Use limits",
        "Limits.stopSupplyState": "Stop product supply",
        "Limits.cardLimitsHeader": "Limits",
        "Limits.dayVolume": "Day volume",
        "Limits.monthVolume": "Month volume",
        "Limits.totalVolume": "Total volume",
        "Limits.publisherName": "Order creator",
        "Limits.orderDate": "Limit Date",
        "Limits.mechanicName": "Oil recevier",
        "Limits.isFullyUsed": "Fully used",
        "Limits.isActive": "Active",
        "Limits.onlyActiveFilter": "Active",
        "Limits.onlyNotActiveFilter": "Not active",
        "Limits.activityAllFilter": "All",        
        "Limits.movingTs": "Moving date",
        "Limits.movingNumber": "Moving number", 
        "AccessLevel.Read": "Read",
        "AccessLevel.Write": "Write",
        "RoleManagement.roleName": "Role name",
        "RoleManagement.roleDescription": "Description",
        "RoleManagement.ModuleClaimsTitle": "Modules Access",
        "RoleManagement.FieldClaimsTitle": "Field Access",
        "RoleManagement.roleNameAlreadyExistsError": "Same role name is already exists",
        "RoleManagement.removeRolePopupHeader": "Role removing",
        "RoleManagement.removeRolePopupMessage": "Do you want remove the role {role name}?",
        "RoleManagement.Claims.Tanks": "Tanks",
        "RoleManagement.Claims.Areas": "Areas",
        "RoleManagement.Claims.TankOperations": "TankOperations",
        "RoleManagement.Claims.Cards": "Cards",
        "RoleManagement.Claims.Administration": "Administration",
        "OrderHistory.OrderId": "Order ID",
        "OrderHistory.OrderNumber": "Car/User",
        "OrderHistory.ActionType": "Action type",
        "OrderHistory.Description": "Action description",
        "OrderHistory.PublisherName": "User name",
        "OrderHistory.ActionTs": "Action time"

    }
}

export default en;